export default __webpack_public_path__ + "static/media/grpc.7496365b.svg";